/**
 * `templateNames.ts` — port of Unity's
 * `Models/Utils/TemplateNames.cs`. Used to seed the default name on
 * brand-new projects / scenes (e.g. `"Splendid project"`,
 * `"Stellar scene"`).
 *
 * The list is verbatim from Unity so cross-platform sessions keep
 * picking from the same vocabulary. Keep alphabetical / ordering in
 * sync only by re-copying — do NOT rearrange just to dedupe.
 */

const NAMES: ReadonlyArray<string> = [
  "Splendid",
  "Spectacular",
  "Impressive",
  "Striking",
  "Glorious",
  "Superb",
  "Majestic",
  "Awesome",
  "Inspiring",
  "Breathtaking",
  "Sumptuous",
  "Resplendent",
  "Grand",
  "Imposing",
  "Monumental",
  "Palatial",
  "Noble",
  "Proud",
  "Exalted",
  "Royal",
  "Regal",
  "King",
  "Princely",
  "Opulent",
  "Fine",
  "Luxurious",
  "Lavish",
  "Rich",
  "Brilliant",
  "Radiant",
  "Dazzling",
  "Beautiful",
  "Elegant",
  "Gorgeous",
  "Elevated",
  "Transcendent",
  "Splendiferous",
  "Ritzy",
  "Posh",
  "Splendacious",
  "Magnolious",
  "Uninspiring",
  "Excellent",
  "Admirable",
  "Great",
  "Wonderful",
  "Notable",
  "Masterly",
  "Skilful",
  "Virtuoso",
  "Excellent",
  "Impressive",
  "Coruscating",
  "Marvellous",
  "Tremendous",
  "Super",
  "Terrific",
  "Glorious",
  "Superb",
  "Stellar",
  "Brilliant",
];

export function randomTemplateName(): string {
  return NAMES[Math.floor(Math.random() * NAMES.length)];
}
